export const HEADER = [
    { title: 'ДАТА НАЧАЛА', fieldName: '' },
    { title: 'СПЕЦИАЛЬНОСТЬ', fieldName: '' },
    { title: 'ТРЕБУЕТСЯ', fieldName: '' },
];
